module.exports = __webpack_public_path__ + "img/allegro.d72cf4c9.png";